export default __webpack_public_path__ + "static/media/1420.a68ad621.png";